import Toggle from './Toggle'

const HasMediaToggle = ({
    hasMedia,
    onToggle
}: {
    hasMedia: boolean
    onToggle: (isEnabled: boolean) => Promise<void>
}) => {
    return (
        <Toggle
            loading={false}
            checked={hasMedia}
            onToggle={onToggle}
            label={'Has images'}
            tooltip={'Only show content that has images attached'}
            disabled={false}
            id={'hasMediaCheckbox'}
            size={'medium'}
        />
    )
}

export default HasMediaToggle
